<template>
  <div class="newslist">
    <div class="header">新闻公告列表</div>
    <div class="list">
      <div class="list-header">
        <div class="number">序号</div>
        <div class="list-header-theme">主题</div>
        <div class="date">日期</div>
      </div>
      <ul class="list-details">
        <li v-for="(item,index) in list" :key="index" @click="hrefto(item.Id)">
          <div class="number">{{parseInt(currentPage)+index+1}}</div>
          <div class="list-details-theme">
            <p>{{item.Title}}</p>
          </div>
          <div class="date">{{item.CreationTime | getdate}}</div>
        </li>
      </ul>
    </div>

    <div class="paginate_container">
      <paginate
        v-model="nowPage"
        :page-count="pageCount"
        :margin-pages="marginPages"
        :page-range="rangePage"
        :click-handler="pageEvent"
        prev-text
        next-text
        :container-class="'pagination'"
        :page-class="'page-item'"
        :page-link-class="'page-link-item'"
        :prev-class="'prev-item'"
        :prev-link-class="'prev-link-item'"
        :next-class="'next-item'"
        :next-link-class="'next-link-item'"
      ></paginate>
    </div>
  </div>
</template>
<script>
import { getNews } from "../../assets/js/modules/newsApi.js";

import paginate from "vuejs-paginate";
export default {
  data() {
    return {
      nowPage: 0,
      pageCount: 20,
      marginPages: 2,
      rangePage: 5,
      list: [],
      currentPage: 0,
      MaxCount: 10
    };
  },
  methods: {
    pageEvent(e) {
      this.currentPage = (e - 1) * this.MaxCount;
      this.nowPage = e;
      this.getnews();
    },
    hrefto(id) {
      this.$router.push({
        path: "/news/newsdetails/",
        query: { Id: id, Page: this.currentPage }
      });
    },
    getnews() {
      let data = {
        SkipCount: this.currentPage,
        MaxResultCount: this.MaxCount
      };
      getNews(data).then(res => {
        this.list = res.data.Data.Items;
        this.pageCount = Math.ceil(res.data.Data.TotalCount / 10);
      });
    }
  },
  mounted() {
    this.currentPage = this.$route.query.Page
      ? this.$route.query.Page
      : this.currentPage;
    this.nowPage = this.$route.query.Page ? 2 : this.initPage;
    this.getnews();
  },
  components: { paginate },
  filters: {
    getdate: value => {
      return value ? value.substring(0, 10) : "";
    }
  }
};
</script>

<style scoped>
.newslist {
  width: 1280px;
  background: #fff;
  margin: 30px auto;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  color: #333333;
  padding-bottom: 30px;
}
.header {
  font-size: 20px;
  text-align: center;
  line-height: 70px;
}
.list {
  width: 1014px;
  margin: 0 auto;
  border-top: 1px solid #e7e7e7;
}
.list-header {
  display: flex;
  line-height: 60px;
  text-align: center;
  background: #f8f7f7;
  border-bottom: 1px solid #e7e7e7;
}
.number {
  width: 110px;
}
.list-header-theme {
  flex: 1;
  border-left: 1px solid #e7e7e7;
  border-right: 1px solid #e7e7e7;
}
.date {
  width: 150px;
}
.list-details {
  padding-bottom: 50px;
}
.list-details li {
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  color: #000;
}

.list-details-theme {
  -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1; /* OLD - Firefox 19- */
  width: 20%; /* For old syntax, otherwise collapses. */
  -webkit-flex: 1; /* Chrome */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  overflow: hidden;
}
.list-details-theme p {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 auto;
  text-align: left;
}
.list-details li:hover {
  background: #f3f6f9;
  color: #6aa9ff;
}
.list-details li:hover .date {
  color: #6aa9ff;
}
.list-details .date {
  color: #a8a8a8;
}
.pagination {
  display: flex;
}
.theme {
  float: left;
}

.paginate_container >>> .pagination {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.paginate_container >>> .page-item {
  margin: 0 6px;
}
.paginate_container >>> .page-item a {
  background: #f5f5f5;
  font-size: 14px;
  line-height: 2;
  border-radius: 14px;
  padding: 0 6px;
  outline: none;
}
.paginate_container >>> .page-item.active .page-link-item {
  background: #6aa9ff;
  color: #fff;
}

.paginate_container >>> .prev-link-item {
  display: block;
  width: 24px;
  height: 24px;
  background: url("../../assets/img/previous_icon.png") no-repeat center;
}

.paginate_container >>> .next-link-item {
  display: block;
  width: 24px;
  height: 24px;
  background: url("../../assets/img/next_icon.png") no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/news/newslist.vue